export default __webpack_public_path__ + "c887385178c5b84b3f1004c7aa4ab742.svg";